// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__pDkBW","tab":"ProcedureTabs_tab__3PQ6d"};